import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { LogsNav, PaymentCapacity, Solicitud } from 'src/app/interfaces/interfaces.index';
import { swalError } from 'src/app/shared/config/swalCommon';
import Swal from 'sweetalert2';
import { PaymentCapacityService } from '../../../services/payment-capacity.service';
import { FormGroup, FormBuilder, Validators, AbstractControl, FormControl } from '@angular/forms';
import { NgbCalendar, NgbDatepickerConfig, NgbDate, NgbDatepickerI18n, NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap';
import { LogsService, UserService } from 'src/app/services/services.index';

@Component({
  selector: 'app-rechazo',
  templateUrl: './rechazo.component.html',
  styleUrls: ['./rechazo.component.css']
})
export class RechazoComponent implements OnInit {

  solicitud = {} as Solicitud;
  id: number;
  capacidad = {
    id: 0,
    account: {
      secondHolder: {
        documentNumber: "5555555"
      }
    }
  } as PaymentCapacity;
  viewRechazo: boolean = true;

  constructor(
    private activatedRoute: ActivatedRoute,
    private capacidad_pago: PaymentCapacityService,
    private SpinnerService: NgxSpinnerService,
    private userService: UserService
  ) {}

  ngOnInit(): void {
    this.addLogsNav();
    this.activatedRoute.paramMap.subscribe((res: any) => {
      this.id = res.params.id;
    });
  }

  addLogsNav(){
    const logNav: LogsNav = {
      logType: 'Log de Navegación',
      visitedPage: location.href,
      userId: this.userService.user.id,
      petitionId: 0,
      stepCompleted: ''
    };

  }

  getValues() {
    this.capacidad_pago.getPaymentCapacityById(this.id).subscribe(
      data => {
        this.capacidad = data
    },
    error => this.handleError(error));
  }

  handleError = (err) => {
    this.SpinnerService.hide();
    Swal.fire(swalError('Ha ocurrido un error', err?.userMessage));
  }

  showFormulario() {
     this.viewRechazo = (this.viewRechazo) ? false : true
  }
}
